import {Container, Button, Box} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React from 'react';
import {Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import {SizeMe} from 'react-sizeme';
import {isFile} from '../../../../Util/validators';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
  contentURL: string;
};

export default function POCToolPdfContent(props: Props) {
  const {contentURL} = props;
  const isLocalFileUrl: boolean = isFile(contentURL);

  const ensureProtocol = (url: string): string => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      // If the URL is missing a protocol, add "https://" by default
      return 'https://' + url;
    }
    return url;
  };

  const isValidURL = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  const contentURLWithProtocol = ensureProtocol(contentURL);
  // Check if the URL is from the same origin or a local file
  const isSameOrigin: boolean =
    (isValidURL(contentURLWithProtocol) &&
      new URL(contentURLWithProtocol).origin.endsWith('acep.org')) ||
    /blob\.core\.windows\.net/.test(contentURLWithProtocol);

  const filePath: string =
    isLocalFileUrl || isSameOrigin
      ? contentURL
      : `/api/Service/ExternalPdf?URL=${contentURL}`;

  const handleViewPDF = () => {
    if (isLocalFileUrl) {
      const newTab = window.open();
      return newTab.document.write(
        `<iframe width="100%" height="100%" src="${contentURL}"></iframe>`,
      );
    }
    return window.open(contentURL, '_blank');
  };

  return (
    <>
      <Container style={styles.pdfContainer}>
        <SizeMe>
          {({size}) => (
            <Document file={filePath}>
              <Page
                pageNumber={1}
                renderTextLayer={false}
                width={size.width ? size.width : 1}
              />
            </Document>
          )}
        </SizeMe>
      </Container>
      <Button
        style={styles.button as React.CSSProperties}
        variant="contained"
        onClick={handleViewPDF}>
        <Box m={1}>
          <VisibilityIcon />
        </Box>
        VIEW PDF
      </Button>
    </>
  );
}

const styles = {
  button: {
    width: '100%',
    backgroundColor: 'black',
    height: 52,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    marginBottom: 30,
    marginTop: 20,
  },
  pdfContainer: {
    boxShadow: '0px 0px 5px 0px rgba(191, 194, 199)',
    marginTop: 10,
  },
  IconButton: {
    color: 'white',
  },
};
